import { TargetSchemaItem } from '../authentication-method-policy-utlity';
import {
    AuthenticationMethodsCertificateBasedSchema,
    CertificateBasedAuthenticationMethodConfigurationForm,
} from './model';

export function updateAuthenticationMethodsCertificateBasedSchema(
    form: CertificateBasedAuthenticationMethodConfigurationForm,
): AuthenticationMethodsCertificateBasedSchema {
    // If state is disabled, only return state property
    if (form.state === 'disabled') {
        return {
            type: 'object',
            properties: {
                state: { type: 'string', const: form.state },
            },
        };
    }

    const includedTargetsOneOfItems: TargetSchemaItem[] = form.includeTargets.includedGroups.map((group) => ({
        properties: {
            id: { type: 'string', const: group.id },
            targetType: { type: 'string', const: 'group' },
        },
    }));

    const excludeTargetsOneOfItems: TargetSchemaItem[] = form.excludeTargets.map((group) => ({
        properties: {
            id: { type: 'string', const: group },
            targetType: { type: 'string', const: 'group' },
        },
    }));

    return {
        type: 'object',
        properties: {
            state: { type: 'string', const: form.state },

            includeTargets:
                includedTargetsOneOfItems.length > 0
                    ? {
                          type: 'array',
                          items: {
                              type: 'object',
                              oneOf: includedTargetsOneOfItems,
                          },
                          minItems: includedTargetsOneOfItems.length,
                          maxItems: includedTargetsOneOfItems.length,
                      }
                    : {
                          type: 'array',
                          maxItems: 0,
                      },

            excludeTargets:
                excludeTargetsOneOfItems.length > 0
                    ? {
                          type: 'array',
                          items: {
                              type: 'object',
                              oneOf: excludeTargetsOneOfItems,
                          },
                          minItems: excludeTargetsOneOfItems.length,
                          maxItems: excludeTargetsOneOfItems.length,
                      }
                    : {
                          type: 'array',
                          maxItems: 0,
                      },

            authenticationModeConfiguration: {
                type: 'object',
                properties: {
                    x509CertificateAuthenticationDefaultMode: {
                        type: 'string',
                        const: form.authenticationModeConfiguration.x509CertificateAuthenticationDefaultMode,
                    },
                    x509CertificateDefaultRequiredAffinityLevel: {
                        type: 'string',
                        const: form.authenticationModeConfiguration.x509CertificateDefaultRequiredAffinityLevel,
                    },
                },
            },

            certificateUserBindings: {
                type: 'array',
                items: (form.certificateUserBindings ?? []).map((binding) => ({
                    type: 'object' as const,
                    properties: {
                        x509CertificateField: {
                            type: 'string' as const,
                            const: binding.x509CertificateField,
                        },
                        userProperty: {
                            type: 'string' as const,
                            const: binding.userProperty,
                        },
                        priority: {
                            type: 'number' as const,
                            const: binding.priority,
                        },
                        trustAffinityLevel: {
                            type: 'string' as const,
                            const: binding.trustAffinityLevel as 'low' | 'high',
                        },
                    },
                })),
                minItems: form.certificateUserBindings?.length ?? 0,
                maxItems: form.certificateUserBindings?.length ?? 0,
            },

            crlValidationConfiguration: {
                type: 'object',
                properties: {
                    state: {
                        type: 'string',
                        const: form.crlValidationConfiguration.state,
                    },
                },
            },

            issuerHintsConfiguration: {
                type: 'object',
                properties: {
                    state: {
                        type: 'string',
                        const: form.issuerHintsConfiguration.state,
                    },
                },
            },
        },
    };
}
